import { useState } from 'react';
import { Link } from 'react-router';
import { Logo } from './logo';
import { postJson } from '~/lib/http';
import { useCopy } from '~/lib/copy';

export function SiteFooter({ host }: { host: string }) {
  const t = useCopy();
  const year = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [state, setState] = useState<'idle' | 'busy' | 'done' | 'error'>('idle');

  async function subscribe(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    setState('busy');
    const res = await postJson('/api/subscribe', { email });
    setState(res.ok ? 'done' : 'error');
  }

  const webcal = `webcal://${host}/calendar.ics`;

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <Logo tone="onDark" height={38} />
            <p className="footer-tagline">
              Every networking event in the Bay — one place, always current.
            </p>
          </div>

          <nav aria-label="Explore">
            <h2 className="footer-head">Explore</h2>
            <ul className="footer-links">
              <li>
                <Link to="/">The calendar</Link>
              </li>
              <li>
                <Link to="/advertise">Advertise</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="For organizers">
            <h2 className="footer-head">Organizers</h2>
            <ul className="footer-links">
              <li>
                <Link to="/submit">List your event — free</Link>
              </li>
              <li>
                <a href="/calendar.ics">Download calendar (.ics)</a>
              </li>
              <li>
                <a href={webcal}>Subscribe (Apple / webcal)</a>
              </li>
            </ul>
          </nav>

          <div>
            <h2 className="footer-head">Weekly digest</h2>
            <p className="footer-tagline footer-blurb">
              The week's networking events in your inbox, every Monday morning.
            </p>
            {state === 'done' ? (
              <p className="small digest-ok" role="status">
                You're on the list. See you Monday.
              </p>
            ) : (
              <form className="digest-form" onSubmit={subscribe}>
                <label className="sr-only" htmlFor="footer-digest-email">
                  Email address
                </label>
                <input
                  id="footer-digest-email"
                  className="ui-input"
                  type="email"
                  placeholder="you@company.com"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="ui-btn btn-primary" disabled={state === 'busy'}>
                  {state === 'busy' ? 'Joining…' : 'Join'}
                </button>
              </form>
            )}
            {state === 'error' && (
              <p className="form-error small" role="alert">
                Couldn't subscribe — try again in a minute.
              </p>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            © {year} {t('footer.rights')}
          </span>
          <span>
            Site by{' '}
            <a href="https://tekavra.com" rel="noopener noreferrer" target="_blank">
              Tekavra Creative
            </a>
            {' · '}
            Skyline photo by Clément Bardot,{' '}
            <a
              href="https://commons.wikimedia.org/wiki/File:Downtown_Tampa,_Florida.jpg"
              rel="noopener noreferrer"
              target="_blank"
            >
              CC BY-SA 4.0
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
